export const RadioButton = {
  baseStyle: {},
  // Styles for the size variations
  sizes: {},
  // Styles for the visual style variations
  variants: {
    'ats-primary': () => ({
      control: {
        borderColor: 'border-color',
        width: '28px',
        height: '28px',
        _checked: {
          background: '#F3F3F9',
          border: 'none',
          _before: {
            background: '#605AFB !important',
          },
          _hover: { background: '#F3F3F9 !important', border: 'none' },
        },
        _active: {
          outline: 'none',
        },
        _focus: {
          boxShadow: 'none',
        },
      },
    }),
    'ats-primary-sm': () => ({
      control: {
        borderColor: '#D9D9D9',
        width: '18px',
        height: '18px',
        _checked: {
          background: '#F3F3F9',
          border: 'none',
          _before: {
            background: '#605AFB !important',
          },
          _hover: { background: '#F3F3F9 !important', border: 'none' },
        },
        _active: {
          outline: 'none',
        },
        _focus: {
          boxShadow: 'none',
        },
      },
    }),
    'ats-no-border': () => ({
      control: {
        borderColor: '#FFFFFF !important',

        _checked: {
          background: '#FFFFFF !important',
          border: 'none',
          _before: {
            background: '#FFFFFF !important',
          },
          _hover: { background: '#FFFFFF !important', border: 'none' },
        },
        _active: {
          outline: 'none',
        },
        _focus: {
          boxShadow: 'none',
        },
        _disabled: {
          backgroundColor: '#FFFFFF !important',
          borderColor: '#FFFFFF !important',
        },
      },
    }),
    primary: () => ({
      control: {
        borderColor: 'border-color',
        width: '28px',
        height: '28px',
        _checked: {
          background: '#F3F3F9',
          border: 'none',
          _before: {
            background: '#605AFB !important',
          },
          _hover: { background: '#F3F3F9 !important', border: 'none' },
        },
        _active: {
          outline: 'none',
        },
        _focus: {
          boxShadow: 'none',
        },
      },
    }),
  },
  // The default `size` or `variant` values
  defaultProps: {},
};
